
// import color from "../../../../constants/color";

import color from "../../../../constants/color";

const style = {
  card:{
    mt:2,
    backgroundColor:"#fff",
    padding:"2%",
    borderRadius:"20px",
    display:"flex",
    alignItems:"center  ",
    justifyContent:"space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },
  
  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px", 
  },
    
  
  checkinBtn: {

    "& svg": {
      mr:1,
    },
    borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },
  checkinBtns: {

    "& svg": {
      mr:1,
    },
    borderBottomRightRadius : 50, 
    borderTopRightRadius : 50, 

    backgroundColor: "#28AA4A",
    color: "#fff", 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },
  csvBtns: {
    borderBottomLeftRadius : 50, 
    borderTopLeftRadius : 50, 
    px:1,
    backgroundColor: color.card,
    color: color.text, 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },

  titleGrid: {
    display: "flex",
    justifyContent: "space-between",
    mb:1,
  },
  valueGrid: {
    display: "flex",
    justifyContent: "space-between",
    mt:3
  },
  greyText: {
    color: color.lightText,
  },
  Text: {
    fontWeight: "500",
  },
  TableHead: {
    color: color.lightText,
    fontWeight: "400",

  },
  tabledata: {
    borderBottom: 0,

  },
  tabledatavalue: {
    borderBottom: 0,
    fontWeight: "500",

  },

  tabledatas: {
    borderBottom: 0,
    fontSize: "14px",
    fontWeight: "600",
    borderTop: "1px solid #DEDEDE"
  },

  tabledatasvalue: {
    borderBottom: 0,
    fontSize: "14px",
    fontWeight: "500",
    borderTop: "1px solid #DEDEDE"
  },





}
export default style;